// src/components/account/tabs/WabaTab.jsx

import React, { useEffect, useState } from 'react';
import { USER_LIST_ENDPOINT } from '../../../config/api';
import { decryptData } from '../../../utils/encrypt';

function WabaTab({ waba, setWaba }) {
  const [userOptions, setUserOptions] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem('suyog_user');
    if (!stored) return;

    const parsed = decryptData(stored);
    const org_id = parsed?.selected_org?.value || parsed?.org_id;
    const currentUserId = parsed?.user_id;

    if (!org_id) return;

    fetch(USER_LIST_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ org_id })
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const options = data.map(user => ({
            id: user.id,
            name: user.name
          }));
          setUserOptions(options);

          // ✅ Pre-select only current user by default
          setWaba(prev => ({
            ...prev,
            access_user_ids: [currentUserId]
          }));
        }
      })
      .catch(err => {
        console.error('Error loading user list:', err);
      });
  }, []);

  const handleCheckboxChange = (userId) => {
    setWaba(prev => {
      const ids = new Set(prev.access_user_ids || []);
      if (ids.has(userId)) {
        ids.delete(userId);
      } else {
        ids.add(userId);
      }
      return { ...prev, access_user_ids: Array.from(ids) };
    });
  };

  return (
    <div>
      <h5 className="mb-3">Select The Sales Representative Team</h5>
      <div className="row">
        <label className="form-label">The First Contact Person(s) to the Customer from the Marketing Team</label>
        <div className="col-12">
          {userOptions.map(user => (
            <div className="form-check" key={user.id}>
              <input
                type="checkbox"
                className="form-check-input"
                id={`waba-user-${user.id}`}
                checked={(waba.access_user_ids || []).includes(user.id)}
                onChange={() => handleCheckboxChange(user.id)}
              />
              <label className="form-check-label" htmlFor={`waba-user-${user.id}`}>
                {user.name}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WabaTab;
